import { render, staticRenderFns } from "./TagsContainer.vue?vue&type=template&id=759c30a8&scoped=true"
import script from "./TagsContainer.vue?vue&type=script&lang=ts"
export * from "./TagsContainer.vue?vue&type=script&lang=ts"
import style0 from "./TagsContainer.vue?vue&type=style&index=0&id=759c30a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c30a8",
  null
  
)

export default component.exports